import { collection, addDoc } from 'firebase/firestore';
import { fstore } from 'services/firebase';
import {
    fetchFoods,
    fetchMarkets,
    fetchFeatured,
    fetchCategories,
    fetchUserTransactions,
    addTransaction as addTransactionRest,
    fetchTransactions as fetchAllTransactions,
    fetchUsers as fetchAllUsers,
    addNewsletterSubscription as addNewsletterSubscriptionRest,
    addContactMessage as addContactMessageRest,
    fetchBlogPosts as fetchBlogPostsRest,
    addBlogPost as addBlogPostRest,
    updateBlogPost as updateBlogPostRest,
    deleteBlogPost as deleteBlogPostRest,
    fetchReviews as fetchReviewsRest,
    addReview as addReviewRest,
    updateReview as updateReviewRest,
    deleteReview as deleteReviewRest
} from 'DBServices/firestoreDBService';

export const fetchReviews = async () => {
    try {
        const reviews = await fetchReviewsRest();
        return Array.isArray(reviews) ? reviews : [];
    } catch (error) {
        console.error('fetchReviews error:', error);
        return [];
    }
};

export const addReview = async (payload) => {
    try {
        return await addReviewRest(payload);
    } catch (error) {
        console.error('addReview error:', error);
        throw error;
    }
};

export const updateReview = async (id, payload) => {
    try {
        return await updateReviewRest(id, payload);
    } catch (error) {
        console.error('updateReview error:', error);
        throw error;
    }
};

export const deleteReview = async (id) => {
    try {
        return await deleteReviewRest(id);
    } catch (error) {
        console.error('deleteReview error:', error);
        throw error;
    }
};

export const addSubscriptionEmail = async (email) => {
    try {
        const payload = {
            email,
            subscribedAt: new Date().toISOString()
        };
        return await addNewsletterSubscriptionRest(payload);
    } catch (error) {
        console.error('addSubscriptionEmail error:', error);
    }
};

export const addContactMessageData = async (payload) => {
    try {
        const data = {
            ...payload,
            createdAt: new Date().toISOString()
        };
        return await addContactMessageRest(data);
    } catch (error) {
        console.error('addContactMessageData error:', error);
    }
};

export const fetchBlogPostsData = async () => {
    try {
        const posts = await fetchBlogPostsRest();
        return Array.isArray(posts) ? posts : [];
    } catch (error) {
        console.error('fetchBlogPostsData error:', error);
        return [];
    }
};

export const addBlogPostData = async (payload) => {
    try {
        return await addBlogPostRest(payload);
    } catch (error) {
        console.error('addBlogPostData error:', error);
    }
};

export const updateBlogPostData = async (id, payload) => {
    try {
        return await updateBlogPostRest(id, payload);
    } catch (error) {
        console.error('updateBlogPostData error:', error);
    }
};

export const deleteBlogPostData = async (id) => {
    try {
        return await deleteBlogPostRest(id);
    } catch (error) {
        console.error('deleteBlogPostData error:', error);
    }
};

export const fetchMarketData = async () => {
    try {
        const markets = await fetchMarkets();
        console.log('[backendCalls] fetchMarketData:', markets?.length, 'items');
        return markets.length ? markets : null;
    } catch (e) {
        console.error('fetchMarketData error:', e);
        return null;
    }
};

export const fetchFoodsData = async () => {
    try {
        const foods = await fetchFoods();
        console.log('[backendCalls] fetchFoodsData:', foods?.length, 'items');
        return foods.length ? foods : null;
    } catch (e) {
        console.error('fetchFoodsData error:', e);
        return null;
    }
};

export const fetchFeaturedData = async () => {
    try {
        const featured = await fetchFeatured();
        console.log('[backendCalls] fetchFeaturedData:', featured?.length, 'items');
        return featured.length ? featured : null;
    } catch (e) {
        console.error('fetchFeaturedData error:', e);
        return null;
    }
};

export const fetchCategoryData = async () => {
    try {
        const categories = await fetchCategories();
        console.log('[backendCalls] fetchCategoryData:', categories?.length, 'items');
        return categories.length ? categories : null;
    } catch (e) {
        console.error('fetchCategoryData error:', e);
        return null;
    }
};

export const fetchTransactionHistory = async (userId, options = {}) => {
    try {
        const transactions = await fetchUserTransactions(userId, options);
        console.log('[backendCalls] fetchTransactionHistory:', transactions?.length, 'items');
        return transactions.length ? transactions : [];
    } catch (e) {
        console.error('fetchTransactionHistory error:', e);
        return [];
    }
};

export const fetchTransactions = async () => {
    try {
        const transactions = await fetchAllTransactions();
        console.log('[backendCalls] fetchTransactions:', transactions?.length, 'items');
        return transactions.length ? transactions : [];
    } catch (e) {
        console.error('fetchTransactions error:', e);
        return [];
    }
};

export const fetchUsers = async () => {
    try {
        const users = await fetchAllUsers();
        console.log('[backendCalls] fetchUsers:', users?.length, 'items');
        return users.length ? users : [];
    } catch (e) {
        console.error('fetchUsers error:', e);
        return [];
    }
};

export const addTransaction = async (transactionData) => {
    try {
        const docId = await addTransactionRest(transactionData);
        console.log('[backendCalls] addTransaction success, ID:', docId);
        return docId;
    } catch (e) {
        console.error('addTransaction error:', e);
        throw e;
    }
};